import { Component } from '@angular/core';
import { LeaderboardType } from '@fgb/core';
@Component({
  selector: 'fgb-fantasy-leaderboard-page',
  templateUrl: './fantasy-leaderboard-page.component.html',
  styleUrls: ['./fantasy-leaderboard-page.component.scss'],
})
export class FantasyLeaderboardPageComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.FantasyPoints;
}
